import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@ubisend/pulse-components';

const ImportScope = ({ content }) => {
  return (
    <Button variant="inline" as={Link} to={`/knowledge-bases/${content.id}`}>
      {content.name}
    </Button>
  );
};

ImportScope.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default ImportScope;
